import { Injectable } from "@angular/core";
import { Constants } from "../utils/constants";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApiResponse } from "../classes/api-response";
import { map } from "rxjs/operators";
import { LogEvents } from "../model/logEvents";

@Injectable({
  providedIn: 'root'
})
export class TamperingAttemptLogsService {

  private readonly entities = Constants.entities;
  private readonly ctrlFullPath = `${environment.apiUrl}/getAllLogs`;
  private readonly ctrlFullPathDownload = `${environment.apiUrl}/boxLogs`;


  constructor(private http: HttpClient) {
  }

  public getAllTamperingAttemptLogs() {
    return this.http
      .get<ApiResponse>(`${this.ctrlFullPath}`)
      .pipe(map(value => value.data as LogEvents[]));
  }
  public getUrlForDownloadS3Obj(idBoxLog: number) {
    return this.http
      .get<ApiResponse>(`${this.ctrlFullPathDownload}/${idBoxLog}/files/download_file_from_s3`)
      .pipe(map(value => value.data as string));
  }

  public getAllTamperingAttemptLogsByCompany(companyId?: number) {
    return this.http
      .get<ApiResponse>(`${environment.apiUrl}/getBoxLogsCustomer/${companyId}`)
      .pipe(map(value => value.data as LogEvents[]));
  }
}

